import { IPreExistingConditions, TOnBoardSymptomsProps } from '@stores/interfaces';
import { Button, Checkbox } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';
import { updatePreExistingConditionAgree } from '@stores/onBoard/onBoard';
import { useTypedDispatch, useTypedSelector } from '@stores/index';
import { getPreExistingConditions } from '@stores/settings/setings';
import { CONTENT_MANAGER_MOCK_DATA } from '@pages/Settings/contentManagerMockData';

const PreExistingConditions = (props: TOnBoardSymptomsProps) => {
	const { setActiveStep, setProgressPercent , setNavigatorDirection} = props;
	const { t } = useTranslation();
	const [isChecked, setIsChecked] = useState(false);
  const user = useTypedSelector((state) => state.user)
  const dispatch = useTypedDispatch();
  const selectedUser = useTypedSelector((state) => state.contacts.main.selectedUser);
	const [preExistingConditions, setPreExistingConditions] = useState<IPreExistingConditions>();
  const preExistingConditionAgree = useTypedSelector((state) => state.onBoard.onBoard.preExistingConditionAgree)
	const preConditions = useTypedSelector(state => state.settings.settings.preExistingConditions);
	

	useEffect(() => {
		setPreExistingConditions({
			...preExistingConditions,
			title: preConditions?.title
				? preConditions?.title
				: CONTENT_MANAGER_MOCK_DATA.preExistingConditions?.title,
			description: preConditions?.description
				? preConditions?.description
				: CONTENT_MANAGER_MOCK_DATA.preExistingConditions?.description,
			thumbnail: preConditions?.thumbnail
				? preConditions?.thumbnail
				: CONTENT_MANAGER_MOCK_DATA.preExistingConditions?.thumbnail,
		});
	}, [preConditions]);

  useEffect(() => {
		dispatch(getPreExistingConditions());
    if(user?.profile?.preExistingConditionsRead || selectedUser?.profile?.preExistingConditionsRead){
      setIsChecked(true);
    } else if (preExistingConditionAgree){
      setIsChecked(true);
    }
  },[])

	const handleNextClick = async() => {
    const id = user?.id || selectedUser?.id;
    const savedData = await dispatch(updatePreExistingConditionAgree(id))
		if (savedData.payload) {
			setNavigatorDirection('forward')
			setActiveStep!(6);
			setProgressPercent(60);
		}
	};

	const renderHtml = (str: string) => {
    return <div dangerouslySetInnerHTML={{ __html: str }} />;
  };

	const nextButtonStyle = {
		height: '43px',
		background: 'var(--onboard-button-color)',
		color: '#fff',
		width: '308px',
		border: 'none',
	};

	return (
		<div className="container-div">
			<h2 className="heading">{t('Patient.data.onboard.preExistingTitle')}</h2>
			<span className="subtext">{t('Patient.data.onboard.preExistingDescription1')} <span className="bold-text-css">{t('Patient.data.onboard.yes')}</span> {t('Patient.data.onboard.preExistingDescription2')}</span>
			<div className="content-wrapper">
				<div className="image-container">
					<img
						src={preExistingConditions?.thumbnail}
						alt={t('Patient.data.onboard.preExistingTitle')}
						className="image"
					/>
				</div>
				<div className="questions-container">
					{renderHtml(preExistingConditions?.description!)}
				</div>
			</div>
			<div className="checkbox-container">
				<Checkbox
					checked={isChecked}
					onChange={e => setIsChecked(e.target.checked)}>
					{preExistingConditions?.title}
				</Checkbox>
			</div>
			<div className="button-container-pre-existing">
				<Button
					className="back-button-pre"
					onClick={() => { setNavigatorDirection('backward'); setActiveStep!(2)}}
					size="large"
					block
					style={nextButtonStyle}>
					{t('Patient.data.onboard.back')}
				</Button>
				<Button
					className="proceed-button-pre"
					size="large"
					block
					disabled={!isChecked}
					onClick={handleNextClick}
					style={nextButtonStyle}>
					{t('Patient.data.onboard.proceed')}
				</Button>
			</div>
		</div>
	);
};

export default PreExistingConditions;
